/**
 * Ogrenci yuzunde (katalog, kurs detay, landing, favoriler...) gosterilecek
 * ogrenci sayisi.
 *
 * Backend public kurs yanitlarinda `display_student_count` dondurur
 * (gercek kayit + legacy_student_count). `enrolled_count` ham sayac olarak
 * kalir. Backend henuz deploy edilmediyse alan yoktur; bu durumda bugunku
 * davranis (`enrolled_count`) aynen korunur.
 *
 * Admin / egitmen / raporlama ekranlari GERCEK sayiyi gormeli: orada bu
 * yardimci KULLANILMAZ, ham `enrolled_count` okunur.
 *
 * @param {{display_student_count?: number|null, enrolled_count?: number|null}|null|undefined} course
 * @returns {number}
 */
export function getStudentCount(course) {
  return course?.display_student_count ?? course?.enrolled_count ?? 0;
}
